import React from "react";
import Style from "./AccessDenied.module.scss";
import { useIntl } from "react-intl";
import { getLocalizedMessage } from "../../UtilityFunctions/utils";

function AccessDenied() {
  const intl = useIntl();

  return (
    <div className={Style["access-denied"]}>
      <div>
        <h1 className={Style["access-denied-heading"]}>
          {getLocalizedMessage(intl, "accessDenied")}
        </h1>
        <hr className={Style["hr-line"]} />
        <p className={Style["access-denied-desc"]}>
          {getLocalizedMessage(intl, "accessDenied.permissionDenied")}
        </p>
        <p className={Style["emoji"]}>🚫🚫🚫🚫</p>
        <h6 class={Style["err-code"]}>
          {getLocalizedMessage(intl, "error.forbidden")}
        </h6>
      </div>
    </div>
  );
}

export default AccessDenied;
